import { DtoBase } from "../Utils/DtoBase";
import { Guid } from "../Utils/Guid";
import { Network } from "./Network";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface DiscoveryResultJson extends DtoBaseJson {
//	name: string;
//	agent_id: string;
//	discovery_result_type: string;
//	network: NetworkJson;
//}

export enum DiscoveryResultType { Manual = 1, ScheduledRaw = 2, ScheduledRollup = 3, AgentRollup = 4 };

export class DiscoveryResult extends DtoBase {

	public Name: string;
	public Network: Network;
	public Type: DiscoveryResultType;

	public get HasName(): boolean {
		return !!this.Name;
	}

	public get HasType(): boolean {
		return !!this.Type;
	}

	public get HasNetwork(): boolean {
		return !!this.Network;
	}

	//public static FromJson(json: DiscoveryResultJson): DiscoveryResult {
	//	var result = new DiscoveryResult();

	//	result.CopyDtoBaseJson(json);

 //       if (json.name !== undefined)
 //           result.Name = json.name;
 //       if (json.agent_id !== undefined)
 //           result.AgentGUID = Guid.FromString(json.agent_id);
 //       if (json.discovery_result_type !== undefined)
	//		result.Type = DiscoveryResultType[json.discovery_result_type];

 //       if (json.network !== undefined)
	//		result.Network = Network.FromJson(json.network);

	//	return result;
	//}

	public static readonly ObjSerName = "DiscoveryResult.ObjSerName";

	public Write(obj: any, context: any): void {

		let objSerName: string = context[DiscoveryResult.ObjSerName];

		obj[objSerName] = {};
		obj = obj[objSerName];

		super.Write(obj, context);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasNetwork)
			this.Network.Write(obj, context);

		if (this.HasType)
			obj.discovery_result_type = DiscoveryResultType[this.Type];
	}

	public Read(obj: any, context: any): void {

		let objSerName: string = context[DiscoveryResult.ObjSerName];

		if (!obj[objSerName])
			throw new Error();
		obj = obj[objSerName];

		super.Read(obj, context);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.network !== undefined) {
			this.Network = new Network();
			this.Network.Read(obj, context);
		}

		if (obj.discovery_result_type !== undefined)
			this.Type = DiscoveryResultType[<string>obj.discovery_result_type];
	}

}
